export const faApprove = {
  prefix: "fas",
  iconName: "approve",
  icon: [
    24,
    24,
    [],
    null,
    "M8.4 17.6L0 9.4l2.5-2.5 5.9 5.7L21.5 0 24 2.5 8.4 17.6z"
  ]
};

export const faBellRing = {
  prefix: "fas",
  iconName: "bell-ring",
  icon: [
    24,
    24,
    [],
    null,
    "M3.09,8.72A8.49,8.49,0,0,1,5.71,2.6L4.12,1.09A10.66,10.66,0,0,0,.86,8.72Zm20,0a10.66,10.66,0,0,0-3.26-7.64L18.29,2.6a8.49,8.49,0,0,1,2.63,6.13ZM18.36,16V8.8a6.44,6.44,0,0,0-5.25-6.52V.05H10.89V2.28A6.44,6.44,0,0,0,5.64,8.8V16a2.57,2.57,0,0,1-2.39,2.39v1.59h17.5V18.35A2.57,2.57,0,0,1,18.36,16Zm-2.63,5.57a3.57,3.57,0,0,1-6.76,0Z"
  ]
};

export const faDownload = {
  prefix: "fas",
  iconName: "download",
  icon: [
    24,
    24,
    [],
    null,
    "M11 3v10.586l-3.293-3.293-1.414 1.414L12 17.414l5.707-5.707-1.414-1.414L13 13.586V3h-2zM2 16v3c0 1.093.907 2 2 2h16c1.093 0 2-.907 2-2v-3h-2v3H4v-3H2z"
  ]
};

export const faFavoriteAddress = {
  prefix: "fas",
  iconName: "favorite-address",
  icon: [
    24,
    24,
    [],
    null,
    "M13.6,19.6c0,0.3,0,0.5,0.1,0.8L10,24L3,17.1C-1,13.2-1,6.9,2.9,3S13.1-1,17,2.9c2.8,2.8,3.7,7,2.3,10.7  C16.1,13.8,13.6,16.4,13.6,19.6z M10,5.6c-2.4,0-4.4,2-4.4,4.4s2,4.4,4.4,4.4s4.4-2,4.4-4.4l0,0C14.4,7.6,12.4,5.6,10,5.6z   M21.2,18.6l2.8,0.4l-2,2l0.5,2.9L20,22.6L17.5,24l0.5-2.9l-2-2l2.8-0.4L20,16L21.2,18.6z"
  ]
};

export const faHelmet = {
  prefix: "fas",
  iconName: "helmet",
  icon: [
    24,
    24,
    [],
    null,
    "M8.537 10.638c0 1.024 0.79 1.843 1.775 1.9 3.245 3.298 7.959 4.359 10.18 4.687-0.03 0.03-0.053 0.048-0.053 0.048L17.275 21 3.966 16.296s-2.558-4.48 0.65-9.494c3.208-5.013 11.098-5.68 14.436 1.73 0.03 0.066 0.051 0.123 0.08 0.187h-8.718c-1.038 0-1.877 0.859-1.877 1.92zm3.752 0c0-0.027-0.014-0.048-0.015-0.074h7.616c0.868 2.306 1.122 3.852 1.11 4.866-1.776-0.24-6.033-1.078-9.019-3.802 0.178-0.294 0.308-0.62 0.308-0.99z"
  ]
};

export const faHelp = {
  prefix: "fas",
  iconName: "help",
  icon: [
    24,
    24,
    [],
    null,
    "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm-.78,18.26a1.3,1.3,0,1,1,1.3-1.3A1.3,1.3,0,0,1,11.22,18.26Zm4.23-8.35A5.08,5.08,0,0,1,13.59,12c-1.28,1-1.32,1.35-1.32,2.36H10.62a3.89,3.89,0,0,1,.34-2,4.4,4.4,0,0,1,1.18-1.28c1.12-.88,1.59-1.34,1.59-2.28S12.95,7.4,11.89,7.4a5.9,5.9,0,0,0-2.82.78L8.37,6.69a7.43,7.43,0,0,1,3.67-1,4,4,0,0,1,2.63.81,2.76,2.76,0,0,1,1,2.24A3.19,3.19,0,0,1,15.45,9.91Z"
  ]
};

export const faHexagonBullet = {
  prefix: "fas",
  iconName: "hexagon-bullet",
  icon: [24, 24, [], null, "M12 6l5.196 3v6L12 18l-5.196-3V9z"]
};

export const faHistory = {
  prefix: "fas",
  iconName: "history",
  icon: [
    24,
    24,
    [],
    null,
    "M8.4516129,13.9677419 C8.80792565,13.9677419 9.09677419,14.2565905 9.09677419,14.6129032 L9.09677419,20.4193548 C9.09677419,20.7756676 8.80792565,21.0645161 8.4516129,21.0645161 L2.64516129,21.0645161 C2.28884855,21.0645161 2,20.7756676 2,20.4193548 L2,14.6129032 C2,14.2565905 2.28884855,13.9677419 2.64516129,13.9677419 L8.4516129,13.9677419 Z M19.4193548,18.483871 C19.7756676,18.483871 20.0645161,18.7727195 20.0645161,19.1290323 L20.0645161,20.4193548 C20.0645161,20.7756676 19.7756676,21.0645161 19.4193548,21.0645161 L12.9677419,21.0645161 C12.6114292,21.0645161 12.3225806,20.7756676 12.3225806,20.4193548 L12.3225806,19.1290323 C12.3225806,18.7727195 12.6114292,18.483871 12.9677419,18.483871 L19.4193548,18.483871 Z M21.3548387,13.9677419 C21.7111515,13.9677419 22,14.2565905 22,14.6129032 L22,15.9032258 C22,16.2595385 21.7111515,16.5483871 21.3548387,16.5483871 L12.9677419,16.5483871 C12.6114292,16.5483871 12.3225806,16.2595385 12.3225806,15.9032258 L12.3225806,14.6129032 C12.3225806,14.2565905 12.6114292,13.9677419 12.9677419,13.9677419 L21.3548387,13.9677419 Z M8.4516129,3 C8.80792565,3 9.09677419,3.28884855 9.09677419,3.64516129 L9.09677419,9.4516129 C9.09677419,9.80792565 8.80792565,10.0967742 8.4516129,10.0967742 L2.64516129,10.0967742 C2.28884855,10.0967742 2,9.80792565 2,9.4516129 L2,3.64516129 C2,3.28884855 2.28884855,3 2.64516129,3 L8.4516129,3 Z M19.4193548,7.51612903 C19.7756676,7.51612903 20.0645161,7.80497758 20.0645161,8.16129032 L20.0645161,9.4516129 C20.0645161,9.80792565 19.7756676,10.0967742 19.4193548,10.0967742 L12.9677419,10.0967742 C12.6114292,10.0967742 12.3225806,9.80792565 12.3225806,9.4516129 L12.3225806,8.16129032 C12.3225806,7.80497758 12.6114292,7.51612903 12.9677419,7.51612903 L19.4193548,7.51612903 Z M21.3548387,3 C21.7111515,3 22,3.28884855 22,3.64516129 L22,4.93548387 C22,5.29179661 21.7111515,5.58064516 21.3548387,5.58064516 L12.9677419,5.58064516 C12.6114292,5.58064516 12.3225806,5.29179661 12.3225806,4.93548387 L12.3225806,3.64516129 C12.3225806,3.28884855 12.6114292,3 12.9677419,3 L21.3548387,3 Z"
  ]
};

export const faInvoices = {
  prefix: "fas",
  iconName: "invoices",
  icon: [
    24,
    24,
    [],
    null,
    "M10.6875,7.71428571 C9.87267686,7.66550914 9.17343637,8.30481474 9.125,9.14285714 L9.125,9.14285714 C9.17343637,9.98089955 9.87267686,10.6202051 10.6875,10.5714286 L13.8125,10.5714286 C16.4166667,10.5714286 18.5,12.4928571 18.5,14.8571429 L18.5,14.8571429 C18.5,17.2214286 16.4166667,19.1428571 13.8125,19.1428571 L13.5,22 L11,22 L10.6875,19.1428571 C8.08333333,19.1428571 6,17.2214286 6,14.8571429 L9.125,14.8571429 C9.17343637,15.6951853 9.87267686,16.3344909 10.6875,16.2857143 L13.8125,16.2857143 C14.6273231,16.3344909 15.3265636,15.6951853 15.375,14.8571429 L15.375,14.8571429 C15.3265636,14.0191005 14.6273231,13.3797949 13.8125,13.4285714 L10.6875,13.4285714 C8.08333333,13.4285714 6,11.5071429 6,9.14285714 L6,9.14285714 C6,6.77142857 8.08333333,4.85714286 10.6875,4.85714286 L10.6875,4.85714286 L11,2 L13.5,2 L13.8125,4.85714286 C16.4166667,4.85714286 18.5,6.77857143 18.5,9.14285714 L15.375,9.14285714 C15.3265636,8.30481474 14.6273231,7.66550914 13.8125,7.71428571 L10.6875,7.71428571 Z"
  ]
};

export const faLogOut = {
  prefix: "fas",
  iconName: "log-out",
  icon: [
    24,
    24,
    [],
    null,
    "M3.31,21H8.56v3H3.06A2.76,2.76,0,0,1,.32,21.25V2.75A2.76,2.76,0,0,1,3.06,0H8.55V3H3.3ZM23.37,10.94v-.05l-.15-.2a.1.1,0,0,0-.06-.08l-.07-.07-.08,0-5.7-6-1.94,2,3.7,4H6.31v3H19.06l-3.67,4,1.95,2,5.85-6.1a1.35,1.35,0,0,0,.28-.48,2.1,2.1,0,0,0-.1-2Z"
  ]
};

export const faPhoneCall = {
  prefix: "fas",
  iconName: "phone-call",
  icon: [
    24,
    24,
    [],
    null,
    "M5.0293 3.0098c-1.13 0-2.07.9403-2 2.0703.265 4.269 2.1044 8.1082 4.9434 10.9472 2.839 2.839 6.6782 4.6784 10.9472 4.9434 1.13.07 2.0703-.87 2.0703-2v-1.7305c0-1.02-.7595-1.8702-1.7695-1.9902l-2.5215-.289c-.61-.07-1.2087.1383-1.6387.5683l-1.8496 1.8516a14.9891 14.9891 0 01-3.8183-2.7735 14.9891 14.9891 0 01-2.7735-3.8183l1.8516-1.8496c.43-.43.6384-1.0287.5684-1.6387L8.75 4.7793c-.12-1.01-.9702-1.7695-1.9902-1.7695H5.0293zm8.0488.0527c-.573-.067-1.0781.384-1.0781.959v.084c0 .476.3493.8883.8223.9433 1.727.202 3.263 1.0319 4.371 2.2559.942 1.042 1.576 2.369 1.756 3.836.06.493.4843.8593.9823.8593h.002c.6 0 1.074-.526 1-1.121-.508-4.089-3.7605-7.3285-7.8555-7.8165zm-.1054 4.0527c-.5198-.0038-.9727.4152-.9727.963v.082c0 .458.3295.8234.7715.9414.493.131.936.3836 1.295.7246.39.371.682.8458.828 1.3808.125.455.5026.793.9746.793.653 0 1.1357-.618.9727-1.25-.457-1.774-1.8625-3.1665-3.6445-3.6055a.9696.9696 0 00-.2246-.0293z"
  ]
};

export const faPrint = {
  prefix: "fas",
  iconName: "print",
  icon: [
    24,
    24,
    [],
    null,
    "M7 3a1 1 0 00-1 1v2a1 1 0 001 1h10a1 1 0 001-1V4a1 1 0 00-1-1H7zM5 9c-1.65 0-3 1.35-3 3v4a2 2 0 002 2h2v2a2 2 0 002 2h8a2 2 0 002-2v-2h2a2 2 0 002-2v-4c0-1.65-1.35-3-3-3H5zm14 2c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zM8.5 15h7a.5.5 0 01.5.5v4a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5z"
  ]
};

export const faRestaurant = {
  prefix: "fas",
  iconName: "restaurant",
  icon: [
    24,
    24,
    [],
    null,
    "M2.48,2.53A1.16,1.16,0,0,1,3.64,1.37H20.38a1.16,1.16,0,1,1,0,2.32H3.64A1.16,1.16,0,0,1,2.48,2.53Zm21.27,9.78a1.67,1.67,0,0,1-1.19.78v7.67a1.87,1.87,0,0,1-1.87,1.87H3.32a1.87,1.87,0,0,1-1.87-1.87V13.1A1.67,1.67,0,0,1,.18,10.67L2,7A1.68,1.68,0,0,1,3.54,6H20.37a1.68,1.68,0,0,1,1.5.91l1.94,3.7A1.68,1.68,0,0,1,23.75,12.31Zm-3.51,1.53a.71.71,0,0,0-.71-.71H4.48a.71.71,0,0,0-.71.71V19.6a.71.71,0,0,0,.71.71H19.54a.71.71,0,0,0,.71-.71Z"
  ]
};

export const faSort = {
  prefix: "fas",
  iconName: "sort",
  icon: [
    24,
    24,
    [],
    null,
    "M18,2 L18,18 L21,18 L17,22 L13,18 L16,18 L16,2 L18,2 Z M7,2 L11,6 L8,5.999 L8,22 L6,22 L6,6 L3,6 L7,2 Z"
  ]
};

export const faStatistics = {
  prefix: "fas",
  iconName: "statistics",
  icon: [
    24,
    24,
    [],
    null,
    "M23.2222222,22 L1,22 L1,2 L3.22222222,2 L3.22222222,19.7777778 L5.44444444,19.7777778 L5.44444444,17.5555556 L9.88888889,17.5555556 L9.88888889,19.7777778 L12.1111111,19.7777778 L12.1111111,16.4444444 L16.5555556,16.4444444 L16.5555556,19.7777778 L18.7777778,19.7777778 L18.7777778,17.5555556 L23.2222222,17.5555556 L23.2222222,22 M18.7777778,14.2222222 L23.2222222,14.2222222 L23.2222222,16.4444444 L18.7777778,16.4444444 L18.7777778,14.2222222 M12.1111111,5.33333333 L16.5555556,5.33333333 L16.5555556,8.66666667 L12.1111111,8.66666667 L12.1111111,5.33333333 M16.5555556,15.3333333 L12.1111111,15.3333333 L12.1111111,9.77777778 L16.5555556,9.77777778 L16.5555556,15.3333333 M5.44444444,9.77777778 L9.88888889,9.77777778 L9.88888889,12 L5.44444444,12 L5.44444444,9.77777778 M9.88888889,16.4444444 L5.44444444,16.4444444 L5.44444444,13.1111111 L9.88888889,13.1111111 L9.88888889,16.4444444 Z"
  ]
};

export const faZubut = {
  prefix: "fas",
  iconName: "zubut",
  icon: [
    24,
    24,
    [],
    null,
    "M21.4947147,7.58336257 L12.0978113,23.5542385 L2.25702882,17.9791402 L7.08180183,9.78053496 L12.350454,12.7637067 L21.4947147,7.58336257 Z M18.1260289,16.0365403 L21.999883,18.2307886 L14.25159,22.6204548 L18.1260289,16.0365403 Z M2,6.90029168 L5.87853268,9.09921853 L2,15.6901509 L2,6.90029168 Z M12.350454,0.25 L22,5.71632162 L12.350454,11.1838129 L2.70090793,5.71690644 L12.350454,0.25 Z"
  ]
};

export const faZubutBike = {
  prefix: "fas",
  iconName: "zubut-bike",
  icon: [
    24,
    24,
    [],
    null,
    "M16.751,16.7799 C15.631,16.7799 14.719,15.8679 14.719,14.7469 C14.719,14.0789 15.047,13.4899 15.545,13.1199 L16.175,14.9459 C16.262,15.1979 16.498,15.3569 16.751,15.3569 C16.816,15.3569 16.884,15.3459 16.949,15.3229 C17.268,15.2129 17.436,14.8659 17.327,14.5479 L16.696,12.7189 C16.715,12.7179 16.732,12.7139 16.751,12.7139 C17.87,12.7139 18.782,13.6249 18.782,14.7469 C18.782,15.8679 17.87,16.7799 16.751,16.7799 M7.249,16.7799 C6.13,16.7799 5.218,15.8679 5.218,14.7469 C5.218,13.6249 6.13,12.7139 7.249,12.7139 C8.156,12.7139 8.917,13.3149 9.178,14.1359 L7.876,14.1359 C7.54,14.1359 7.268,14.4089 7.268,14.7469 C7.268,15.0839 7.54,15.3569 7.876,15.3569 L9.178,15.3569 C8.917,16.1789 8.156,16.7799 7.249,16.7799 M16.751,11.4929 C16.593,11.4929 16.441,11.5179 16.289,11.5399 L14.8,7.2199 L17.499,7.2199 C17.836,7.2199 18.108,6.9469 18.108,6.6099 C18.108,6.2729 17.836,5.9999 17.499,5.9999 L14.23,5.9999 C13.968,5.9999 13.721,6.1279 13.567,6.3419 C13.416,6.5549 13.376,6.8309 13.462,7.0789 L14.105,8.9429 L10.664,14.1359 L10.439,14.1359 C10.23,13.0499 9.484,12.1539 8.486,11.7409 L9.658,9.9709 L10.69,9.9709 C11.026,9.9709 11.299,9.6979 11.299,9.3609 C11.299,9.0239 11.026,8.7509 10.69,8.7509 L7.876,8.7509 C7.54,8.7509 7.268,9.0239 7.268,9.3609 C7.268,9.6979 7.54,9.9709 7.876,9.9709 L8.196,9.9709 L7.184,11.4999 C5.422,11.5359 4,12.9749 4,14.7469 C4,16.5409 5.457,17.9999 7.249,17.9999 C8.833,17.9999 10.151,16.8599 10.439,15.3569 L10.883,15.3569 C11.155,15.3569 11.408,15.2209 11.561,14.9929 L14.605,10.3939 L15.138,11.9389 C14.165,12.5019 13.501,13.5429 13.501,14.7469 C13.501,16.5409 14.958,17.9999 16.751,17.9999 C18.543,17.9999 20,16.5409 20,14.7469 C20,12.9529 18.543,11.4929 16.751,11.4929"
  ]
};

export const faZubutBikeActive = {
  prefix: "fas",
  iconName: "zubut-bike-active",
  icon: [
    24,
    24,
    [],
    null,
    "m17.56 19.74a2.12 2.12 0 0 1 -2.14-2.1 2.05 2.05 0 0 1 .27-1 11.39 11.39 0 0 0 1.58 1.73.53.53 0 1 0 .69-.81 10.52 10.52 0 0 1 -1.51-1.69 2.16 2.16 0 0 1 1.11-.31 2.1 2.1 0 1 1 0 4.2zm-10.77-2.74a3.27 3.27 0 0 0 -.17-.58l1-.61s.18.77.31 1.16zm-3.36 2.74a2.1 2.1 0 1 1 0-4.2 2.16 2.16 0 0 1 1.37.46l-1.43.78a.68.68 0 0 0 -.35.45.67.67 0 0 0 .66.8h1.85a2.14 2.14 0 0 1 -2.1 1.71zm16.06-4.88.15-.1a.32.32 0 0 0 0-.54 4.19 4.19 0 0 0 -2.52-.57 4.14 4.14 0 0 0 -1.69.54c-.36-.64-.67-1.28-.95-1.9h.75a.52.52 0 0 0 .52-.56 3.87 3.87 0 0 0 -.75-2.07 1.09 1.09 0 0 0 -.86-.41h-.84c-.12-.38-.2-.65-.23-.77a.65.65 0 0 0 -.76-.48 5 5 0 0 0 -2.31 1.36.54.54 0 0 0 -.05.73.54.54 0 0 0 .79 0 4.53 4.53 0 0 1 1.39-1c.12.42.32 1 .58 1.76h-1.6a3.31 3.31 0 0 0 -3.21 2.31h-1.55a2 2 0 0 1 -1.59-.78l-.08-.11a2 2 0 0 0 -1.62-.79h-2.06a.84.84 0 1 0 0 1.68h2.21a4.81 4.81 0 0 1 3.64 1.68l-.85.56a3.45 3.45 0 0 0 -2.54-1.11 3.36 3.36 0 1 0 0 6.72 3.41 3.41 0 0 0 3.4-2.94h1.28a4.69 4.69 0 0 0 4.71 0 6.19 6.19 0 0 1 .93-4.66c.23.48.48 1 .76 1.44a4.08 4.08 0 0 0 -1.08 1.86 3.88 3.88 0 0 0 0 2 .33.33 0 0 0 .5.2l.34-.24a3.44 3.44 0 0 0 6.7-1 3.34 3.34 0 0 0 -1.51-2.81zm.04-11.86a6.53 6.53 0 0 1 4.47 1.77l-1.12 1.06a4.87 4.87 0 0 0 -6.69 0l-1.12-1.06a6.49 6.49 0 0 1 4.46-1.77zm0 3a3.27 3.27 0 0 1 2.23.89l-1.12 1.11a1.62 1.62 0 0 0 -1.11-.45 1.66 1.66 0 0 0 -1.11.45l-1.12-1.11a3.27 3.27 0 0 1 2.23-.89z"
  ]
};

export const faZubutCar = {
  prefix: "fas",
  iconName: "zubut-car",
  icon: [
    24,
    24,
    [],
    null,
    "M17.7041,15.8893 C17.5311,15.8893 17.3771,15.8313 17.2361,15.7503 C16.9451,15.5853 16.7401,15.2853 16.7401,14.9293 C16.7401,14.4003 17.1741,13.9703 17.7041,13.9703 C18.2351,13.9703 18.6681,14.4003 18.6681,14.9293 C18.6681,15.2853 18.4631,15.5853 18.1731,15.7503 C18.0311,15.8313 17.8781,15.8893 17.7041,15.8893 Z M12.1901,10.5743 C11.9061,10.5743 11.6391,10.5753 11.3661,10.5763 L11.3661,8.3123 C11.3661,8.2013 11.4571,8.1113 11.5691,8.1113 L13.3031,8.1113 C13.7551,8.1113 14.1791,8.3253 14.4461,8.6873 L15.8051,10.5283 C15.8551,10.5973 15.8081,10.6943 15.7231,10.6883 C14.6881,10.6193 13.5111,10.5743 12.1901,10.5743 Z M10.2511,10.4813 C10.2511,10.5363 10.2031,10.5813 10.1471,10.5823 C8.9121,10.5913 7.8111,10.6063 6.8711,10.6253 C6.7911,10.6273 6.7471,10.5403 6.7891,10.4723 L7.8031,8.7953 C8.0591,8.3703 8.5211,8.1113 9.0181,8.1113 L10.0481,8.1113 C10.1601,8.1113 10.2511,8.2013 10.2511,8.3123 L10.2511,10.4813 Z M6.8531,15.8893 C6.6801,15.8893 6.5261,15.8313 6.3851,15.7503 C6.0951,15.5853 5.8901,15.2853 5.8901,14.9293 C5.8901,14.4003 6.3221,13.9703 6.8531,13.9703 C7.3841,13.9703 7.8171,14.4003 7.8171,14.9293 C7.8171,15.2853 7.6121,15.5853 7.3211,15.7503 C7.1811,15.8313 7.0261,15.8893 6.8531,15.8893 Z M19.8411,11.1703 C19.3421,11.0803 18.6741,10.9783 17.8601,10.8843 C17.5791,10.8513 17.3191,10.7053 17.1521,10.4783 L15.1331,7.7413 C14.7891,7.2753 14.2431,7.0003 13.6621,7.0003 L8.6181,7.0003 C7.9781,7.0003 7.3851,7.3343 7.0551,7.8803 L5.3731,10.6603 C5.3731,10.6603 4.6431,10.7853 4.2991,10.8473 C3.3331,11.0213 3.0001,11.5893 3.0001,12.2513 L3.0001,14.3363 C3.0001,15.1183 3.6361,15.7503 4.4201,15.7503 L4.9471,15.7503 C5.2671,16.4843 6.0011,17.0003 6.8531,17.0003 C7.7061,17.0003 8.4391,16.4843 8.7601,15.7503 L8.7891,15.7503 L15.5921,15.7503 L15.7981,15.7503 C16.1181,16.4843 16.8511,17.0003 17.7041,17.0003 C18.5581,17.0003 19.2931,16.4833 19.6121,15.7473 C20.3821,15.7283 21.0001,15.1043 21.0001,14.3333 L21.0001,12.5643 C21.0001,11.8803 20.5171,11.2923 19.8411,11.1703 Z"
  ]
};

export const faZubutMotorcycle = {
  prefix: "fas",
  iconName: "zubut-motorcycle",
  icon: [
    24,
    24,
    [],
    null,
    "M19.7089,12.2802186 C19.7509,12.2522186 19.7919,12.2222186 19.8329,12.1942186 C20.0039,12.0792186 19.9949,11.8322186 19.8179,11.7272186 C19.1959,11.3592186 18.4509,11.1712186 17.6569,11.2412186 C17.1349,11.2882186 16.6419,11.4512186 16.2039,11.7032186 C15.8979,11.1572186 15.6279,10.6032186 15.3919,10.0742186 L16.0349,10.0742186 C16.2979,10.0742186 16.5019,9.85121863 16.4799,9.59421863 C16.3979,8.69821863 16.0989,8.13821863 15.8509,7.81921863 C15.6749,7.59321863 15.3999,7.46421863 15.1099,7.46421863 L14.4069,7.46421863 C14.3039,7.13621863 14.2379,6.90321863 14.2119,6.80621863 C14.1349,6.52421863 13.8469,6.35121863 13.5569,6.41221863 C12.6959,6.59321863 11.9699,7.20121863 11.6029,7.56321863 C11.4309,7.73221863 11.3989,8.00621863 11.5559,8.18821863 C11.7319,8.39421863 12.0469,8.40321863 12.2349,8.21621863 C12.4299,8.02321863 12.8899,7.60521863 13.4249,7.39121863 C13.5309,7.75221863 13.6969,8.28021863 13.9259,8.90421863 L12.5509,8.90421863 C10.3469,8.90421863 9.7959,10.8842186 9.7959,10.8842186 L8.4419,10.8842186 C7.9069,10.8842186 7.4029,10.6362186 7.0819,10.2172186 L7.0099,10.1242186 C6.6829,9.69621863 6.1689,9.44421863 5.6229,9.44421863 L3.8749,9.44421863 C3.4859,9.44421863 3.1649,9.74021863 3.1419,10.1202186 C3.1159,10.5342186 3.4509,10.8842186 3.8749,10.8842186 L5.7549,10.8842186 C7.7749,10.8842186 8.8779,12.3232186 8.8779,12.3232186 L8.1169,12.7372186 C7.5789,12.1532186 6.8039,11.7832186 5.9379,11.7832186 C4.3179,11.7832186 2.9999,13.0752186 2.9999,14.6632186 C2.9999,16.2512186 4.3179,17.5422186 5.9379,17.5422186 C7.4349,17.5422186 8.6709,16.4412186 8.8529,15.0232186 L9.9799,15.0232186 C11.9999,16.2822186 14.0209,15.0232186 14.0209,15.0232186 C13.7239,12.6962186 14.5059,11.4272186 14.8169,11.0262186 C15.0139,11.4352186 15.2299,11.8512186 15.4659,12.2622186 C15.0259,12.6972186 14.6979,13.2432186 14.5359,13.8572186 C14.3779,14.4572186 14.3939,15.0322186 14.5309,15.5612186 C14.5799,15.7482186 14.7999,15.8372186 14.9639,15.7302186 C15.0639,15.6642186 15.1599,15.5942186 15.2569,15.5252186 C15.6319,16.6932186 16.7469,17.5422186 18.0619,17.5422186 C19.6819,17.5422186 20.9999,16.2512186 20.9999,14.6632186 C20.9999,13.6732186 20.4869,12.7992186 19.7089,12.2802186 Z M5.9379,16.4632186 C4.9259,16.4632186 4.1029,15.6552186 4.1029,14.6632186 C4.1029,13.6712186 4.9259,12.8632186 5.9379,12.8632186 C6.3869,12.8632186 6.7969,13.0212186 7.1149,13.2822186 L5.8859,13.9522186 C5.7349,14.0342186 5.6179,14.1722186 5.5839,14.3372186 C5.5079,14.7022186 5.7899,15.0232186 6.1489,15.0232186 L7.7379,15.0232186 C7.5669,15.8432186 6.8259,16.4632186 5.9379,16.4632186 Z M8.8239,14.1232186 C8.7899,13.9502186 8.7399,13.7832186 8.6759,13.6232186 L9.5209,13.1002186 C9.5209,13.1002186 9.6709,13.7562186 9.7859,14.0952186 L9.7959,14.1232186 L8.8239,14.1232186 Z M18.0619,16.4632186 C17.0489,16.4632186 16.2249,15.6552186 16.2249,14.6632186 C16.2249,14.3432186 16.3109,14.0442186 16.4599,13.7842186 C16.8699,14.3292186 17.3209,14.8352186 17.8159,15.2682186 C17.9039,15.3442186 18.0139,15.3822186 18.1219,15.3822186 C18.2549,15.3822186 18.3879,15.3262186 18.4799,15.2152186 C18.6389,15.0242186 18.5919,14.7412186 18.4039,14.5752186 C17.9329,14.1592186 17.5019,13.6632186 17.1099,13.1262186 C17.3879,12.9612186 17.7129,12.8632186 18.0619,12.8632186 C19.0739,12.8632186 19.8979,13.6712186 19.8979,14.6632186 C19.8979,15.6552186 19.0739,16.4632186 18.0619,16.4632186 Z"
  ]
};

export const faBusiness = {
  prefix: "fas",
  iconName: "business",
  icon: [
    24,
    24,
    [],
    null,
    "M9,3 C8.57575,3 8.1514219,3.1347969 7.7949219,3.4042969 L2.7949219,7.1777344 C2.2939219,7.5557344 2,8.1464375 2,8.7734375 L2,20 C2,20.552 2.448,21 3,21 L16,21 L20.5,21 C21.317063,21 22,20.317063 22,19.5 L22,8.8027344 C22,8.1766325 21.703691,7.5819986 21.203125,7.2050781 L16.167969,3.4042969 C15.830369,3.1493542 15.429525,3.0139551 15.023438,3.0019531 C14.617349,2.9899511 14.205893,3.1010191 13.853516,3.3359375 L11.869141,4.6601562 L10.205078,3.4042969 C9.8485781,3.1347969 9.42425,3 9,3 Z M14.962891,5 L20,8.8027344 L20,19 L16,19 L16,17 L17.5,17 C17.776,17 18,16.776 18,16.5 L18,15.5 C18,15.224 17.776,15 17.5,15 L16,15 L16,13 L17.5,13 C17.776,13 18,12.776 18,12.5 L18,11.5 C18,11.224 17.776,11 17.5,11 L16,11 L16,8.7734375 C16,8.1464375 15.706078,7.5557344 15.205078,7.1777344 L13.558594,5.9355469 L14.962891,5 Z M6.5,9 L7.5,9 C7.776,9 8,9.224 8,9.5 L8,10.5 C8,10.776 7.776,11 7.5,11 L6.5,11 C6.224,11 6,10.776 6,10.5 L6,9.5 C6,9.224 6.224,9 6.5,9 Z M10.5,9 L11.5,9 C11.776,9 12,9.224 12,9.5 L12,10.5 C12,10.776 11.776,11 11.5,11 L10.5,11 C10.224,11 10,10.776 10,10.5 L10,9.5 C10,9.224 10.224,9 10.5,9 Z M6.5,13 L7.5,13 C7.776,13 8,13.224 8,13.5 L8,14.5 C8,14.776 7.776,15 7.5,15 L6.5,15 C6.224,15 6,14.776 6,14.5 L6,13.5 C6,13.224 6.224,13 6.5,13 Z M10.5,13 L11.5,13 C11.776,13 12,13.224 12,13.5 L12,14.5 C12,14.776 11.776,15 11.5,15 L10.5,15 C10.224,15 10,14.776 10,14.5 L10,13.5 C10,13.224 10.224,13 10.5,13 Z M6.5,17 L7.5,17 C7.776,17 8,17.224 8,17.5 L8,18.5 C8,18.776 7.776,19 7.5,19 L6.5,19 C6.224,19 6,18.776 6,18.5 L6,17.5 C6,17.224 6.224,17 6.5,17 Z M10.5,17 L11.5,17 C11.776,17 12,17.224 12,17.5 L12,18.5 C12,18.776 11.776,19 11.5,19 L10.5,19 C10.224,19 10,18.776 10,18.5 L10,17.5 C10,17.224 10.224,17 10.5,17 Z"
  ]
};

export const faAdd = {
  prefix: "fas",
  iconName: "add",
  icon: [16, 16, [], null, "M13 7H9V3H7v4H3v2h4v4h2V9h4z"]
};

export const faOptions = {
  prefix: "fas",
  iconName: "options",
  icon: [
    15,
    15,
    [],
    null,
    "M12.242 3H7.9996v.66667h4.2424c.23418 0 .42424-.14933.42424-.33333s-.19006-.33333-.42424-.33333zM2.42424 3.75h.90873c.18964.71667.84848 1.25 1.6367 1.25.93588 0 1.697-.7475 1.697-1.6667 0-.91917-.76109-1.6667-1.697-1.6667-.78824 0-1.4471.53333-1.6367 1.25h-.90873C2.19006 2.9166 2 3.10327 2 3.33327s.19006.41667.42424.41667zM12.222 6.3333h-.88889v.66667h.88889c.24533 0 .44444-.14933.44444-.33333s-.19911-.33333-.44444-.33333zM2.45614 7.0833h4.6262c.20389.71667.91228 1.25 1.7598 1.25 1.0062 0 1.8246-.7475 1.8246-1.6667 0-.91917-.81832-1.6667-1.8246-1.6667-.84751 0-1.5559.53333-1.7598 1.25h-4.6262C2.20435 6.2499 2 6.43657 2 6.66657s.20435.41667.45614.41667zM12.242 10.3333H7.9996v.66667h4.2424c.23418 0 .42424-.14933.42424-.33333s-.19006-.33333-.42424-.33333zM4.9697 9c-.78824 0-1.4471.53333-1.6367 1.25h-.90873c-.23418 0-.42424.18667-.42424.41667s.19006.41667.42424.41667H3.333c.18964.71667.84848 1.25 1.6367 1.25.93588 0 1.697-.7475 1.697-1.6667 0-.91917-.76109-1.6667-1.697-1.6667z"
  ]
};

export const faIncidence = {
  prefix: "fas",
  iconName: "incidence",
  icon: [
    24,
    24,
    [],
    null,
    "M22.239,18.451 L13.442,3.816 C13.135,3.305 12.596,3 12,3 C11.404,3 10.865,3.305 10.559,3.815 L1.761,18.451 C1.449,18.97 1.441,19.619 1.739,20.146 C2.036,20.673 2.597,21 3.203,21 L20.798,21 C21.403,21 21.965,20.673 22.262,20.146 C22.56,19.619 22.551,18.97 22.239,18.451 Z M13,18 L11,18 L11,16 L13,16 L13,18 Z M13,14 L11,14 L11,9 L13,9 L13,14 Z"
  ]
};

export const faArrowDropDown = {
  prefix: "fas",
  iconName: "drop-down",
  icon: [24, 24, [], null, "M7 10l5 5 5-5z"]
};

export const faWhatsApp = {
  prefix: "fas",
  iconName: "whatsapp",
  icon: [
    24,
    24,
    [],
    null,
    "M19.077,4.928C17.191,3.041,14.683,2.001,12.011,2c-5.506,0-9.987,4.479-9.989,9.985 c-0.001,1.76,0.459,3.478,1.333,4.992L2,22l5.233-1.237c1.459,0.796,3.101,1.215,4.773,1.216h0.004 c5.505,0,9.986-4.48,9.989-9.985C22.001,9.325,20.963,6.816,19.077,4.928z M16.898,15.554c-0.208,0.583-1.227,1.145-1.685,1.186 c-0.458,0.042-0.887,0.207-2.995-0.624c-2.537-1-4.139-3.601-4.263-3.767c-0.125-0.167-1.019-1.353-1.019-2.581 S7.581,7.936,7.81,7.687c0.229-0.25,0.499-0.312,0.666-0.312c0.166,0,0.333,0,0.478,0.006c0.178,0.007,0.375,0.016,0.562,0.431 c0.222,0.494,0.707,1.728,0.769,1.853s0.104,0.271,0.021,0.437s-0.125,0.27-0.249,0.416c-0.125,0.146-0.262,0.325-0.374,0.437 c-0.125,0.124-0.255,0.26-0.11,0.509c0.146,0.25,0.646,1.067,1.388,1.728c0.954,0.85,1.757,1.113,2.007,1.239 c0.25,0.125,0.395,0.104,0.541-0.063c0.146-0.166,0.624-0.728,0.79-0.978s0.333-0.208,0.562-0.125s1.456,0.687,1.705,0.812 c0.25,0.125,0.416,0.187,0.478,0.291C17.106,14.471,17.106,14.971,16.898,15.554z"
  ]
};

export const faSignFile = {
  prefix: "fas",
  iconName: "sign-file",
  icon: [
    20,
    20,
    [],
    null,
    "M6,2 C4.9,2 4,2.9 4,4 L4,20 C4,21.1 4.9,22 6,22 L18,22 C19.1,22 20,21.1 20,20 L20,8 L14,2 L6,2 Z M13,3.5 L18.5,9 L13,9 L13,3.5 Z M10.453125,11.011719 C11.038875,11.011719 11.627078,11.240125 12.080078,11.703125 C12.732078,12.368125 13.013,13.346531 13,14.019531 C12.983,14.936531 12.479922,15.955031 11.669922,16.832031 C11.837922,16.939031 11.994,17 12.125,17 C12.509,17 12.766656,16.72925 13.222656,16.15625 C13.633656,15.64125 14.146,15 15,15 C15.444,15 15.836938,15.293703 15.960938,15.720703 C16.080937,16.118703 16.511,17 17,17 L17,19 C15.927,19 15.149437,18.326219 14.648438,17.574219 C14.142437,18.197219 13.395,19 12.125,19 C11.411,19 10.700219,18.655234 10.074219,18.115234 C9.1572188,18.656234 8.098,19 7,19 L7,17 C7.616,17 8.2311094,16.818203 8.7871094,16.533203 C8.3231094,15.730203 8.0289531,14.840156 8.0019531,14.035156 C7.9779531,13.351156 8.1876094,12.377406 8.8496094,11.691406 C9.2856094,11.240406 9.867375,11.011719 10.453125,11.011719 Z M10.457031,13 C10.409031,13 10.360109,13.006031 10.287109,13.082031 C10.114109,13.261031 9.9870469,13.647844 9.9980469,13.964844 C10.014047,14.400844 10.159047,14.859203 10.373047,15.283203 C10.758047,14.828203 10.993,14.357469 11,13.980469 C11.004,13.770469 10.882344,13.337516 10.652344,13.103516 C10.550344,12.999516 10.487031,13 10.457031,13 Z"
  ]
};

export const faReload = {
  prefix: "fas",
  iconName: "reload",
  icon: [
    24,
    24,
    [],
    null,
    "M3.954 7.99l1.514 1.514C5.17 10.28 5 11.12 5 12c0 3.86 3.141 7 7 7v-3l4 4-4 4v-3c-4.963 0-9-4.038-9-9 0-1.442.349-2.801.954-4.01zM12 0v3c4.963 0 9 4.038 9 9 0 1.442-.349 2.801-.954 4.01l-1.514-1.514C18.83 13.72 19 12.88 19 12c0-3.86-3.141-7-7-7v3L8 4l4-4z"
  ]
};

export const faCopyDestination = {
  prefix: "fas",
  iconName: "copy-destination",
  icon: [
    20,
    20,
    [],
    null,
    "M4,2 C2.895,2 2,2.895 2,4 L2,17 C2,17.552 2.448,18 3,18 C3.552,18 4,17.552 4,17 L4,4 L17,4 C17.552,4 18,3.552 18,3 C18,2.448 17.552,2 17,2 L4,2 Z M8,6 C6.895,6 6,6.895 6,8 L6,20 C6,21.105 6.895,22 8,22 L20,22 C21.105,22 22,21.105 22,20 L22,8 C22,6.895 21.105,6 20,6 L8,6 Z M8,8 L20,8 L20,20 L8,20 L8,8 Z"
  ]
};
